var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EnableFactorModalView',_vm._b({attrs:{"handleContinue":_vm.enableWebAuthn,"showModal":_vm.showModal},on:{"close-modal":_vm.handleModalClose}},'EnableFactorModalView',_vm.$data,false))
}
var staticRenderFns = []

export { render, staticRenderFns }